module.exports = __webpack_public_path__ + "img/emp6-2.18420f0f.jpg";